import { PropsWithChildren } from 'react';

import { Icon } from 'components/icon';
import { ErrorColor, ErrorPadding } from 'types';
import { CloseButton } from 'components/specified-buttons';

import * as Styles from './styles';
import { ErrorAlertProps } from './types';

const ErrorAlert = ({
  onClose,
  hideIcon,
  children,
  className,
  alignCenter,
  regularText,
  color = ErrorColor.Red,
  padding = ErrorPadding.Default,
  icon = <Icon.AlertError width={48} height={48} />,
}: PropsWithChildren<ErrorAlertProps>) => {
  return (
    <Styles.Error color={color} padding={padding} className={className}>
      <Styles.Info alignCenter={alignCenter}>
        {!hideIcon && icon}
        {regularText ? children : <Styles.Text>{children} </Styles.Text>}
      </Styles.Info>
      {onClose && <CloseButton onClose={onClose} />}
    </Styles.Error>
  );
};

export { ErrorAlert };
